import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneRinging = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.81223 0.848221H2.11039C1.50273 0.848221 1.01013 1.34083 1.01013 1.94848V14.0513C1.01013 14.659 1.50273 15.1517 2.11039 15.1517H9.81223C10.4199 15.1517 10.9125 14.659 10.9125 14.0513V1.94848C10.9125 1.34083 10.4199 0.848221 9.81223 0.848221Z",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.41101 12.4009H6.51127",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7769 3.87549C17.7769 6.15366 17.7769 9.84731 15.7769 12.1255",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6342 5.37466C14.6341 6.82441 14.6341 9.17491 13.6342 10.6247",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPhoneRinging;
